import {
  getUserPlacesFn,
  type Address,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useGetUserPlace = (
  opts?: Omit<
    UseQueryOptions<Address[], DefaultQueryError>,
    'queryKey' | 'queryFn'
  >
) =>
  useQuery<Address[], DefaultQueryError>({
    queryKey: ['user-place'],
    queryFn: getUserPlacesFn,
    ...opts,
  });
